<template>
  <div
    class="
        p-6
        min-w-40
        max-h-44
        w-fit-content
        mx-5
        rounded-xl
        shadow-md
        flex
        items-center
        space-x-4
        blur-xl
        bg-gray-400
        bg-opacity-30
        justify-items-center
      "
  >
    <div class="flex-shrink-0 mx-2">
      <transition
        enter-active-class="animate__animated animate__backInLeft"
        leave-active-class="animate__animated animate__fadeOut"
        mode="out-in"
      >
        <img
          class="h-32 w-32 rounded-lg"
          :key="albumimg"
          v-show="albumimg"
          :src="albumimg"
          alt=""
        />
        <!-- <img class="h-32 w-32 rounded-lg" :src="'D:/Snip/Snip_Artwork.jpg'" alt="" /> -->
      </transition>
    </div>
    <div class="justify-items-center">
      <transition
        enter-active-class="animate__animated animate__backInDown"
        leave-active-class="animate__animated animate__fadeOut"
        mode="out-in"
      >
        <p
          v-if="title === 'Paused'"
          :key="title"
          class="text-5xl font-bold text-white"
        >
          <span class="fas fa-pause-circle animate-flicker"></span> Song
          {{ title }}
        </p>
        <p v-else :key="title" class="text-4xl font-bold text-white text-center mb-2">
          {{ title }}
        </p>
      </transition>
      <transition
        enter-active-class="animate__animated animate__backInDown"
        leave-active-class="animate__animated animate__fadeOut"
        mode="out-in"
      >
        <p v-if="title === 'Paused'" :key="artist" class="text-white font-medium text-2xl text-center"></p>
        <p v-else :key="artist" class="text-white font-medium text-3xl text-center">
          {{ artist }}
        </p>
      </transition>
    </div>
  </div>
</template>

<script>
import PostService from "../PostService";

export default {
  name: "Overlay",
  data() {
    return {
      title: "",
      is_playing: Boolean,
      artist: "",
      albumimg: "",
      progress: 0,
      song_length: 0,
    };
  },
  methods: {
    async assignSong() {
      try {
        this.song = await PostService.getSong();
        this.title = this.song.track;
        this.is_playing = this.song.is_playing;
        this.artist = this.song.artist;
        this.albumimg = this.song.albumimg;
        this.progress = this.song.progress;
        this.song_length = this.song.song_length;
      } catch (err) {
        this.error = err;
      }
    },
    async interval() {
      await this.assignSong();
      setInterval(await this.assignSong, 5000);
    },
  },
  async created() {
    await this.assignSong();
    await this.interval();
    // setInterval(this.assignSong, 100000);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.scale-in-center {
  -webkit-animation: scale-in-center 1.5s ease-in-out 0.5s infinite both;
  animation: scale-in-center 1.5s ease-in-out 0.5s infinite both;
}
@-webkit-keyframes scale-in-center {
  0% {
    -webkit-transform: scale(0);
    transform: scale(0);
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes scale-in-center {
  0% {
    -webkit-transform: scale(0);
    transform: scale(0);
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
    opacity: 1;
  }
}
@-webkit-keyframes flickerAnimation{
  0%   { opacity:1; }
  50%  { opacity:0; }
  100% { opacity:1; }
}
.animate-flicker {
   -webkit-animation: flickerAnimation 2s infinite;
   -moz-animation: flickerAnimation 2s infinite;
   -o-animation: flickerAnimation 2s infinite;
    animation: flickerAnimation 2s infinite;
}
</style>
